import React, { useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function MigratePage() {
  const [status, setStatus] = useState('idle'); // idle | running | done | error
  const [result, setResult] = useState(null);

  const runMigration = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      setStatus('error');
      setResult({ message: 'Not logged in. Please log in first.' });
      return;
    }
    setStatus('running');
    setResult(null);
    try {
      const res = await axios.post(`${API}/migrate/import-skus-from-atlas`, {}, {
        headers: { Authorization: `Bearer ${token}` },
        timeout: 120000,
      });
      setStatus('done');
      setResult(res.data);
    } catch (err) {
      setStatus('error');
      setResult({ message: err.response?.data?.detail || err.message });
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'sans-serif' }}>
      <div style={{ background: '#fff', borderRadius: 12, padding: 40, maxWidth: 520, width: '100%', boxShadow: '0 4px 24px rgba(0,0,0,0.10)' }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 8, color: '#0f172a' }}>Database Migration</h1>
        <p style={{ color: '#64748b', marginBottom: 24, lineHeight: 1.6 }}>
          This will copy the <strong>2004 SKUs</strong> from the Atlas database into the production database.
          Existing SKUs are skipped — safe to run multiple times.
        </p>

        <button
          onClick={runMigration}
          disabled={status === 'running'}
          style={{
            background: status === 'running' ? '#94a3b8' : '#0d9488',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            padding: '12px 28px',
            fontSize: 15,
            fontWeight: 600,
            cursor: status === 'running' ? 'not-allowed' : 'pointer',
            width: '100%',
            marginBottom: 20,
          }}
          data-testid="run-migration-btn"
        >
          {status === 'running' ? 'Importing SKUs... (may take ~30s)' : 'Import 2004 SKUs from Atlas'}
        </button>

        {status === 'done' && result && (
          <div style={{ background: '#f0fdf4', border: '1px solid #86efac', borderRadius: 8, padding: 16 }}>
            <p style={{ color: '#166534', fontWeight: 700, marginBottom: 4 }}>Migration Complete</p>
            <p style={{ color: '#15803d', margin: 0 }}>
              {result.skus_copied} SKUs copied &nbsp;·&nbsp; {result.skus_skipped} already existed
            </p>
            <p style={{ color: '#166534', marginTop: 8, marginBottom: 0 }}>
              Now go to <a href="/inventory" style={{ color: '#0d9488', fontWeight: 600 }}>Inventory → SKU Management</a> to confirm.
            </p>
          </div>
        )}

        {status === 'already_on_atlas' && (
          <div style={{ background: '#eff6ff', border: '1px solid #93c5fd', borderRadius: 8, padding: 16 }}>
            <p style={{ color: '#1d4ed8', margin: 0 }}>Already using Atlas database — no migration needed.</p>
          </div>
        )}

        {status === 'error' && result && (
          <div style={{ background: '#fef2f2', border: '1px solid #fca5a5', borderRadius: 8, padding: 16 }}>
            <p style={{ color: '#dc2626', fontWeight: 700, marginBottom: 4 }}>Error</p>
            <p style={{ color: '#b91c1c', margin: 0 }}>{result.message}</p>
            <p style={{ color: '#b91c1c', marginTop: 8, marginBottom: 0 }}>Make sure you are logged in as super admin (nitinj@lsnminerals.com).</p>
          </div>
        )}

        <p style={{ color: '#94a3b8', fontSize: 12, marginTop: 24, marginBottom: 0 }}>
          Super admin access required. If you see a 403 error, log in at <a href="/" style={{ color: '#0d9488' }}>the home page</a> first.
        </p>
      </div>
    </div>
  );
}
